import { formatDateTime, formatTime } from "./zoomModel";

export interface PhotoTimes {
  /** 서버에 올라간 시각 */
  createdAt?: string | null;
  /** 실제로 찍은 시각 */
  takenAt?: string | null;
  takenAtSource?: "EXIF" | "FILE" | null;
}

/**
 * 사진의 시각 표시. 촬영 시각이 있으면 그것을, 없으면 등록 시각을 쓴다.
 * 파일 수정 시각에서 읽은 촬영 시각은 앨범에서 고른 시각일 수 있어 "파일 시각"으로 구분한다.
 * @param detail true 면 날짜까지, 그리고 촬영 시각이 있으면 등록 시각도 함께 (크게 보기 제목 아래)
 * @returns 보여줄 시각이 하나도 없으면 빈 문자열
 */
export function photoTimeLabel(photo: PhotoTimes, detail: boolean): string {
  const format = detail ? formatDateTime : formatTime;
  const registered = photo.createdAt ? `등록 ${format(photo.createdAt)}` : "";
  if (!photo.takenAt) return registered;
  const taken = `${photo.takenAtSource === "FILE" ? "파일 시각" : "촬영"} ${format(photo.takenAt)}`;
  return detail && registered ? `${taken} · ${registered}` : taken;
}
